import { interactive } from "@api/courses/exams/interactive/api";
import { fileBased } from "@api/courses/exams/fileBased/api";
import { states } from "@api/courses/exams/stats/api";

export const exams = {
  interactive,
  fileBased,
  states,
};
